import moment, {Moment} from "moment";
import "moment/locale/it";
import "moment/locale/en-gb";
import React, {ReactElement, useMemo} from "react";
import Datetime from "react-datetime";

type DatePickerType = {
	id: string;
	placeholder?: string;
	selectedDay?: Moment | null;
	setSelectedDay: (date: Moment | null) => void;
	allowedRange?: { min: Moment; max: Moment };
	disabled?: boolean;
};

export const ZEERO_DATE_FORMAT = "DD/MM/YYYY";

export default function ZeeroDatePicker({
											id,
											placeholder,
											selectedDay,
											setSelectedDay,
											allowedRange,
											disabled = false,
										}: DatePickerType): ReactElement {

	const inputProps: React.HTMLProps<HTMLInputElement> = useMemo(() => {
		return {
			value: selectedDay ? selectedDay.format(ZEERO_DATE_FORMAT) : "",
			placeholder: placeholder,
			id: id,
			className: "zeero-input",
			autoComplete: "off",
			disabled: disabled,
		}
	}, [selectedDay]);

	const isValidDate = (currentDay: Moment): boolean => {
		if (!allowedRange) {
			return true;
		}

		const min = moment(allowedRange.min);
		const max = moment(allowedRange.max);
		if (!min.isValid() || !max.isValid()) {
			return true;
		}
		return currentDay.isSameOrAfter(min, "day") && currentDay.isSameOrBefore(max, "day");
	};


	return (
			<Datetime
					className="zeero-date-picker"
					isValidDate={isValidDate}
					closeOnSelect
					locale={navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : "en"}
					dateFormat={ZEERO_DATE_FORMAT}
					timeFormat={false}
					inputProps={inputProps}
					onChange={(val) => {
						document.getElementById(id)?.classList.remove("invalid");
						if (moment.isMoment(val) && val.isValid()) {
							const day = val.startOf("day");
							setSelectedDay(day);
						} else {
							if (typeof val === "string" && val.trim()) {
								document.getElementById(id)?.classList.add("invalid");
							} else {
								setSelectedDay(null);
							}
						}
					}}
					renderView={(_, renderCalendar) => {
						return (
								<React.Fragment>
									{renderCalendar()}
									<div
											className="today-button"
											onClick={() => setSelectedDay(moment().startOf("day"))}
									>
										Today
									</div>
								</React.Fragment>
						);
					}}
			/>
	);
}
